import type { RefObject } from 'preact';
import { useState, useCallback } from 'preact/hooks';
import { useResizeObserver } from '#hooks/UNSAFE_useResizeObserver';

const useSize = (
  ref: RefObject<Element>,
  options: Parameters<typeof useResizeObserver>[2] = { box: 'content-box' }
) => {
  const [size, setSize] = useState<{ width: number; height: number }>();

  useResizeObserver(
    ref,
    useCallback(
      (entry) => {
        const boxSize = options.box === 'border-box' ? entry.borderBoxSize : entry.contentBoxSize;
        const newWidth = boxSize[0].inlineSize;
        const newHeight = boxSize[0].blockSize;
        setSize({ width: newWidth, height: newHeight });
      },
      [options]
    ),
    options
  );

  return size;
};

export { useSize };
